import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

interface IWrapped {
	flexWrap: 'wrap' | 'wrap-reverse' | 'no-wrap';
}

const wrapped = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)<IWrapped>`
		flex-wrap: ${({ flexWrap }) => flexWrap};
	`;

export default wrapped;
